// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__IWUC4","anketa":"styles_anketa__x5Nmk","row":"styles_row__I11S7","column":"styles_column__FaqtM"};